import React, { useState } from "react";
import { Typography, Box, Input, Textarea, Button } from "@mui/joy";
import axios from "axios";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/api/inquiry`,
        formData
      );
      setResponseMessage(response.data.message);
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      setResponseMessage(
        err.response?.data.message || "Error submitting inquiry"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", p: 2, mt: 12 }}>
      <Typography level="h4" sx={{ mb: 3, textAlign: "center" }}>
        Contact Us
      </Typography>
      <form onSubmit={handleSubmit}>
        <Input
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          sx={{ mb: 2 }}
          disabled={loading}
        />
        <Input
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          sx={{ mb: 2 }}
          disabled={loading}
        />
        <Textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          minRows={4}
          sx={{ mb: 2 }}
          disabled={loading}
        />
        <Button type="submit" fullWidth sx={{ mb: 2 }} disabled={loading}>
          {loading ? "Submitting..." : "Submit Inquiry"}
        </Button>
      </form>
      {responseMessage && (
        <Typography
          color={responseMessage.includes("Error") ? "danger" : "success"}
          sx={{ mt: 2, textAlign: "center" }}
        >
          {responseMessage}
        </Typography>
      )}
    </Box>
  );
}
